import React, { useEffect, useState } from 'react';
import {
  Container,
  NavbarBrand,
  Navbar,
  Nav,
  NavItem,
  NavbarToggler,
  Collapse,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { routesData } from '../../common';
import { LogoIcon } from '../../common/icons/logoIcon';

/**
 * Full-width Mega Menu Header
 * Uses the uploaded image at:
 *   /mnt/data/771df02d-63d7-475d-b536-59f0958faf4d.png
 * as the purple curved bottom decoration.
 */
const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  // index of currently open mega-menu; null if none
  const [openIndex, setOpenIndex] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const handleMouseEnter = (index) => setOpenIndex(index);
  const handleMouseLeave = () => setOpenIndex(null);
  const handleFocus = (index) => setOpenIndex(index);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 992);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  const handleBlur = (e) => {
    // close when focus leaves the nav area
    // if focus moves outside the nav, close menu
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setOpenIndex(null);
    }
  };

  useEffect(() => {
    let timeoutId = null;

    const handleScroll = () => {
      if (timeoutId === null) {
        timeoutId = setTimeout(() => {
          if (window.scrollY > 100) {
            setScrolled(true);
          } else {
            setScrolled(false);
          }
          timeoutId = null;
        }, 100); // throttle delay in ms
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="topbar" id="top">
      <div className="header6">
        <Navbar className={`navbar-expand-lg h6-nav-bar ${scrolled ? 'headerBackgroundColor1' : ''}`} fixed={scrolled ? 'top' : ''}>
          <Container className="d-flex align-items-center justify-content-between">
            <div className="my-brand-div d-flex align-items-center">
              <NavbarBrand href="/" aria-label="Home">
                <LogoIcon />
              </NavbarBrand>
              <NavbarToggler onClick={toggle}>
                <span className="ti-menu" />
              </NavbarToggler>
            </div>

            <Collapse isOpen={isOpen} navbar className="justify-content-end" id="h6-info">
              <Nav navbar className="ms-auto header-mega-nav">
                {routesData?.map((route, index) => {
                  if (route?.hidden) return null;

                  // 👉 MOBILE VIEW
                  if (isMobile) {
                    if (route?.children?.length > 0) {
                      return (
                        <UncontrolledDropdown nav inNavbar key={index}>
                          <DropdownToggle nav caret>{route.label}</DropdownToggle>

                          <DropdownMenu>
                            {/* <DropdownItem tag={Link} to={route.path}>
                              {route.label} Overview
                            </DropdownItem>
                            <DropdownItem divider /> */}

                            {route.children.map((child, i) =>
                              !child.hidden && (
                                <DropdownItem key={i} tag={Link} to={child.path}>
                                  {child.label}
                                </DropdownItem>
                              )
                            )}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      );
                    }

                    return (
                      <NavItem key={index}>
                        <Link className="nav-link" to={route.path}>
                          {route.label}
                        </Link>
                      </NavItem>
                    );
                  }

                  // 👉 DESKTOP VIEW (MEGA MENU)
                  if (route?.children?.length > 0) {
                    const active = openIndex === index;

                    return (
                      <div
                        key={index}
                        className={`mega-nav-item ${active ? 'open' : ''}`}
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={handleMouseLeave}
                        onFocus={() => handleFocus(index)}
                        onBlur={handleBlur}
                        aria-haspopup="true"
                        aria-expanded={active}
                      >
                        <button className="mega-nav-link nav-link">{route.label}</button>

                        <div className={`mega-panel ${active ? 'visible' : ''}`} role="menu">
                          <Container className="mega-panel-inner">
                            <div className="mega-columns">
                              {route.children.map((child, i) =>
                                !child.hidden && (
                                  <Link key={i} to={child.path} className="panel-link">
                                    <div className="mega-column text-center">{child.label}</div>
                                  </Link>
                                )
                              )}
                            </div>
                          </Container>

                          <div className="mega-bottom-decor" aria-hidden="true" />
                        </div>
                      </div>
                    );
                  }

                  return (
                    <NavItem key={index}>
                      <Link className="nav-link simple-nav-link" to={route.path}>
                        {route.label}
                      </Link>
                    </NavItem>
                  );
                })}
                {/* This section only display mobile devices 
                {routesData?.map((route, index) => {
                  if (route?.hidden) return null;

                  // If route has children → make dropdown
                  if (route?.children?.length > 0) {
                    return (
                      <UncontrolledDropdown nav inNavbar key={index}>
                        <DropdownToggle nav caret>
                          {route.label}
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem tag={Link} to={route.path}>
                            {route.label} Overview
                          </DropdownItem>
                          <DropdownItem divider />
                          {route.children.map((child, childIndex) => (
                            !child.hidden && (
                              <DropdownItem key={childIndex} tag={Link} to={child.path}>
                                {child.label}
                              </DropdownItem>
                            )
                          ))}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    );
                  }

                  // Otherwise → regular NavItem
                  return (
                    <NavItem key={index}>
                      <Link className="nav-link" to={route.path}>
                        {route.label}
                      </Link>
                    </NavItem>
                  );
                })}
                // This section only display web devices 
                {routesData?.map((route, index) => {
                  if (route?.hidden) return null;

                  // For items with children -> show hover-triggered full-width mega panel
                  if (route?.children?.length > 0) {
                    const active = openIndex === index;
                    return (
                      <div
                        key={index}
                        className={`mega-nav-item ${active ? 'open' : ''}`}
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={handleMouseLeave}
                        onFocus={() => handleFocus(index)}
                        onBlur={handleBlur}
                        tabIndex={-1} // container focus handling via children 
                        aria-haspopup="true"
                        aria-expanded={active}
                      >
                        <button
                          className="mega-nav-link nav-link"
                          aria-label={route.label}
                        // keep keyboard users able to focus
                        >
                          {route.label}
                        </button>

                        // Full-width panel 
                        <div className={`mega-panel ${active ? 'visible' : ''}`} role="menu">
                          <Container className="mega-panel-inner">
                            <div className="mega-columns">
                              // OPTIONAL: Parent link/overview as first column 
                              // <div className="mega-column mega-overview">
                                // <Link to={route.path} className="panel-overview-link">
                                  // {route.label} Overview
                                // </Link>
                              // </div>

                              // Render child links in columns. Adjust layout by CSS 
                              {route.children.map((child, i) => (
                                !child.hidden && (
                                  <Link key={i} to={child.path} className="panel-link">
                                    <div className="mega-column text-center">
                                      {child.label}
                                    </div>
                                  </Link>
                                )
                              ))}
                            </div>
                          </Container>

                          // bottom curved purple decoration using uploaded image
                          <div className="mega-bottom-decor" aria-hidden="true" />
                        </div>
                      </div>
                    );
                  }

                  // Regular nav item
                  return (
                    <NavItem key={index}>
                      <Link className="nav-link simple-nav-link" to={route.path}>
                        {route.label}
                      </Link>
                    </NavItem>
                  );
                })} */}
              </Nav>

              <div className="act-buttons">
                <Link to="https://calendly.com/prabhat-asthana-varahisoft/30min" className="btn font-14">Talk to an Expert</Link>
              </div>
            </Collapse>
          </Container>
        </Navbar>
      </div>
    </div>
  );
};

export default Header;